<template>
  <div>
    <div class="card p-4 shadow-sm">
      <!-- Toast -->
      <div v-if="mostrarToast" class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1055">
        <div class="toast show align-items-center text-white" :class="toastColor">
          <div class="d-flex">
            <div class="toast-body">
              <i :class="iconoToast" class="me-2"></i>
              {{ alerta.mensaje }}
            </div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast"></button>
          </div>
        </div>
      </div>

      <!-- Encabezado -->
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h3 class="m-0">Gestión de Mantenimientos</h3>
        <button class="btn btn-success" @click="mostrarFormulario = true">Agregar Mantenimiento</button>
      </div>

      <!-- Formulario -->
      <div v-if="mostrarFormulario" class="mb-4">
        <h5 class="mb-3">Nuevo Mantenimiento</h5>
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label">Habitación</label>
            <select v-model="nuevoMantenimiento.IdHabitacion" class="form-select">
              <option disabled value="">Seleccione una habitación</option>
              <option v-for="hab in habitaciones" :key="hab.IdHabitacion" :value="hab.IdHabitacion">
                {{ hab.Numero }}
              </option>
            </select>
          </div>
          <div class="col-md-6">
            <label class="form-label">Descripción</label>
            <textarea v-model="nuevoMantenimiento.DescripcionMantenimiento" class="form-control" rows="1"></textarea>
          </div>
        </div>
        <div class="text-end mt-3">
          <button class="btn btn-primary me-2" @click="guardarMantenimiento">Guardar</button>
          <button class="btn btn-secondary" @click="cancelarFormulario">Cancelar</button>
        </div>
      </div>

      <!-- Tabla -->
      <div class="table-responsive">
        <table class="table table-bordered text-center align-middle">
          <thead class="table-light">
            <tr>
              <th>Habitación</th>
              <th>Descripción</th>
              <th>Estado</th>
              <th>Fecha</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="mantenimientos.length === 0">
              <td colspan="5">No hay tareas de mantenimiento registradas.</td>
            </tr>
            <tr v-for="m in mantenimientos" :key="m.IdMantenimientoHotel">
              <td>{{ m.habitacion_mantenimiento?.Numero }}</td>
              <td>{{ m.DescripcionMantenimiento }}</td>
              <td>{{ estados[m.EstadoMantenimiento] }}</td>
              <td>{{ new Date(m.FechaCreacion).toLocaleString() }}</td>
              <td>
                <button class="btn btn-primary btn-sm me-2" @click="abrirModal(m)">Editar</button>
                <button class="btn btn-danger btn-sm" @click="abrirModalEliminar(m)">Eliminar</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Modal Editar -->
      <div v-if="mostrarModal" class="modal-backdrop">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Actualizar Mantenimiento</h5>
            <button type="button" class="btn-close" @click="cerrarModal"></button>
          </div>
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-md-12">
                <label class="form-label">Descripción</label>
                <textarea v-model="mantenimientoEditar.DescripcionMantenimiento" class="form-control" rows="2"></textarea>
              </div>
              <div class="col-md-12">
                <label class="form-label">Estado</label>
                <select v-model="mantenimientoEditar.EstadoMantenimiento" class="form-select">
                  <option v-for="(estado, index) in estados" :key="index" :value="index">{{ estado }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer mt-3">
            <button class="btn btn-secondary" @click="cerrarModal">Cancelar</button>
            <button class="btn btn-primary" @click="actualizarMantenimiento">Actualizar</button>
          </div>
        </div>
      </div>

      <!-- Modal Eliminar -->
      <div v-if="mostrarModalEliminar" class="modal-backdrop">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-danger">Confirmar Eliminación</h5>
            <button type="button" class="btn-close" @click="cerrarModalEliminar"></button>
          </div>
          <div class="modal-body">
            <p>¿Eliminar la tarea de mantenimiento para la habitación <strong>{{ mantenimientoEliminar?.habitacion_mantenimiento?.Numero }}</strong>?</p>
          </div>
          <div class="modal-footer mt-3">
            <button class="btn btn-secondary" @click="cerrarModalEliminar">Cancelar</button>
            <button class="btn btn-danger" @click="confirmarEliminar">Eliminar</button>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config.js";

export default {
  name: "GestionMantenimiento",
  data() {
    return {
      mantenimientos: [],
      habitaciones: [],
      mostrarFormulario: false,
      mostrarModal: false,
      mostrarModalEliminar: false,
      mantenimientoEditar: null,
      mantenimientoEliminar: null,
      mostrarToast: false,
      alerta: { mensaje: "", tipo: "success" },
      intervalo: null, // ✅ Para el polling
      nuevoMantenimiento: {
        DescripcionMantenimiento: "",
        IdHabitacion: "",
      },
      estados: [
        "Mantenimiento Creado",
        "Visto",
        "En reparación",
        "Mantenimiento Finalizado",
      ],
    };
  },
  computed: {
    toastColor() {
      return this.alerta.tipo === "success" ? "bg-success" : "bg-danger";
    },
    iconoToast() {
      return this.alerta.tipo === "success" ? "bi bi-check-circle" : "bi bi-exclamation-circle";
    },
  },
  methods: {
    cerrarToast() {
      this.mostrarToast = false;
    },
    mostrarAlerta(mensaje, tipo = "success") {
      this.alerta = { mensaje, tipo };
      this.mostrarToast = true;
      setTimeout(this.cerrarToast, 3000);
    },
    async obtenerMantenimientos() {
  try {
    const res = await axios.get(`${API_URL}/mantenimiento-hotel`);
    this.mantenimientos = res.data.sort((a, b) => new Date(b.FechaCreacion) - new Date(a.FechaCreacion));
  } catch (error) {
    console.error(error);
    this.mostrarAlerta("Error al cargar mantenimientos", "danger");
  }
}
,
    async obtenerHabitaciones() {
      const res = await axios.get(`${API_URL}/habitaciones-para-mantenimiento`);
      this.habitaciones = res.data.habitaciones;
    },
    async guardarMantenimiento() {
      const { DescripcionMantenimiento, IdHabitacion } = this.nuevoMantenimiento;
      if (!DescripcionMantenimiento || !IdHabitacion) {
        this.mostrarAlerta("Todos los campos son obligatorios", "danger");
        return;
      }
      try {
        await axios.post(`${API_URL}/mantenimiento-hotel`, this.nuevoMantenimiento);
        this.mostrarAlerta("Mantenimiento agregado", "success");
        this.nuevoMantenimiento = { DescripcionMantenimiento: "", IdHabitacion: "" };
        this.mostrarFormulario = false;
        this.obtenerMantenimientos();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al guardar", "danger");
      }
    },
    abrirModal(m) {
      this.mantenimientoEditar = { ...m };
      this.mostrarModal = true;
    },
    cerrarModal() {
      this.mantenimientoEditar = null;
      this.mostrarModal = false;
    },
    async actualizarMantenimiento() {
      try {
        await axios.put(`${API_URL}/mantenimiento-hotel/${this.mantenimientoEditar.IdMantenimientoHotel}`, this.mantenimientoEditar);
        this.mostrarAlerta("Mantenimiento actualizado", "success");
        this.cerrarModal();
        this.obtenerMantenimientos();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al actualizar", "danger");
      }
    },
    abrirModalEliminar(m) {
      this.mantenimientoEliminar = { ...m };
      this.mostrarModalEliminar = true;
    },
    cerrarModalEliminar() {
      this.mantenimientoEliminar = null;
      this.mostrarModalEliminar = false;
    },
    async confirmarEliminar() {
      if (!this.mantenimientoEliminar) return;
      try {
        await axios.delete(`${API_URL}/mantenimiento-hotel/${this.mantenimientoEliminar.IdMantenimientoHotel}`);
        this.mostrarAlerta("Mantenimiento eliminado", "success");
        this.obtenerMantenimientos();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al eliminar", "danger");
      } finally {
        this.cerrarModalEliminar();
      }
    },
    cancelarFormulario() {
      this.mostrarFormulario = false;
      this.nuevoMantenimiento = { DescripcionMantenimiento: "", IdHabitacion: "" };
    },
  },
  mounted() {
    this.obtenerMantenimientos();
    this.obtenerHabitaciones();
    this.intervalo = setInterval(this.obtenerMantenimientos, 30000); // ✅ Polling cada 30s
  },
  beforeUnmount() {
    clearInterval(this.intervalo); // ✅ Detener polling al desmontar
  },
};
</script>


<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
.modal-content {
  background: #fff;
  width: 600px;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}
</style>
